import React from 'react';
import { Button } from '../ui/Button';
import { CheckCircle2, Lock } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="bg-slate-900 py-16 sm:py-24 text-white relative overflow-hidden" data-id="element-106">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#4f46e5_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-107"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-108">
        <div className="mx-auto max-w-3xl text-center" data-id="element-109">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6 font-serif" data-id="element-110">
            El Kit de Emergencia que toda argentina debería tener en su celular
          </h2>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-white/20 shadow-2xl mt-8" data-id="element-111">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-8" data-id="element-112">
              <div className="text-left" data-id="element-113">
                <p className="text-blue-200 font-medium mb-1" data-id="element-114">
                  Oferta Especial
                </p>
                <div className="flex items-baseline gap-2" data-id="element-115">
                  <span className="text-5xl font-bold text-white" data-id="element-116">
                    AR$ 8.900
                  </span>
                </div>
                <p className="text-slate-300 mt-2 text-sm max-w-xs" data-id="element-117">
                  Menos de lo que gastás en un delivery que te hace sentir
                  pesada.
                </p>
              </div>

              <div className="w-full md:w-auto" data-id="element-118">
                <Button size="xl" className="w-full bg-blue-600 hover:bg-blue-500 text-white border-none shadow-lg shadow-blue-500/30" data-id="element-119">
                  QUIERO MI KIT SOS AHORA
                </Button>
                <div className="flex items-center justify-center gap-2 mt-3 text-xs text-slate-400" data-id="element-120">
                  <Lock className="w-3 h-3" data-id="element-121" />
                  Pago seguro con Mercado Pago
                </div>
              </div>
            </div>

            <div className="border-t border-white/10 pt-8" data-id="element-122">
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left" data-id="element-123">
                <li className="flex items-center text-slate-200" data-id="element-124">
                  <CheckCircle2 className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" data-id="element-125" />
                  <span data-id="element-126">Acceso inmediato al PDF</span>
                </li>
                <li className="flex items-center text-slate-200" data-id="element-127">
                  <CheckCircle2 className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" data-id="element-128" />
                  <span data-id="element-129">21 Técnicas probadas</span>
                </li>
                <li className="flex items-center text-slate-200" data-id="element-130">
                  <CheckCircle2 className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" data-id="element-131" />
                  <span data-id="element-132">Guía de uso en oficina</span>
                </li>
                <li className="flex items-center text-slate-200" data-id="element-133">
                  <CheckCircle2 className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" data-id="element-134" />
                  <span data-id="element-135">Actualizaciones de por vida</span>
                </li>
              </ul>
            </div>
          </div>

          <p className="mt-8 text-slate-400 text-sm" data-id="element-136">
            Llevate el botiquín emocional que vas a tener para siempre en tu
            celular.
          </p>
        </div>
      </div>
    </section>;
}